import React, {FC} from 'react';
import {Helmet} from 'react-helmet';
import {useTranslation} from 'react-i18next';
import { Heatmapbytypesofproduction } from '../../../components/Grossharvestofproducts/Heatmapbytypesofproduction'; 

const HeatmapbytypesofproductionPage: FC = () => {
    const {t} = useTranslation();

    return (
        <>
            <Helmet>
                <title>Тепловая карта по видам продукции</title>
            </Helmet>
            <Heatmapbytypesofproduction/>
        
        </>
    );
};

export default HeatmapbytypesofproductionPage
